import React from 'react'
import * as R from 'ramda'
import { Link, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import produce from 'immer'

import useAxios, { mutate } from 'hooks/useAxios'
import TestimonialsPageV2 from '.'
import { toast } from 'libs/toast'
import useSaveUserActivityLog, { ACTION_NAME } from 'hooks/useSaveUserActivityLog'
import FeedbackWidgetSettingsContainer from 'components/Admin/FeedbackWidgetSettings/container'
import { ContentContainer } from 'components/ContentContainer'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import useUser from 'hooks/useUser'

export default function TestimonialsPageV2Container() {
  const match = useRouteMatch()
  const userInfo = useUser()
  const companyId = R.path(['selected_workspace', 'id'], userInfo)
  const history = useHistory()
  const saveUserActivityLog = useSaveUserActivityLog()
  const { data: widgets, loading: widgetsLoading } = useAxios({ url: 'widget/' })
  const { fetch: createWidgetAPI, loading: createWidgetAPILoading } = useAxios({
    url: 'widget/',
    method: 'post',
    skip: true,
  })
  const { fetch: deleteWidgetAPI, loading: deleteWidgetAPILoading } = useAxios({
    url: 'widget/',
    method: 'delete',
    skip: true,
  })

  function createWidget(type) {
    createWidgetAPI({
      data: { type },
    })
      .then((response) => {
        toast.success('Nice work! A new widget has been created.')
        saveUserActivityLog({
          action: ACTION_NAME.create_widget,
          target: `com_${companyId}`,
          statusCode: response.status,
          requestBody: { type },
        })
        history.push(
          `/${match.params.workspaceToken}/settings/feedback-widgets/${response.data.id}/`
        )
        mutate(`widget/`, (widgets) => {
          if (widgets) {
            return produce(widgets, (draftWidgets) => {
              draftWidgets.results.unshift(response.data)
            })
          }
        })
      })
      .catch((error) => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
        saveUserActivityLog({
          action: ACTION_NAME.create_widget,
          target: `com_${companyId}`,
          statusCode: error.response.status,
          requestBody: {},
        })
      })
  }

  function deleteWidget(widgetId) {
    deleteWidgetAPI({
      url: `widget/${widgetId}/`,
    })
      .then((response) => {
        toast.success('The widget was successfully deleted.')
        mutate(`widget/`, (widgets) => {
          if (widgets) {
            return produce(widgets, (draftWidgets) => {
              draftWidgets.results = draftWidgets.results.filter((widget) => widget.id !== widgetId)
            })
          }
        })
        saveUserActivityLog({
          action: ACTION_NAME.delete_widget,
          target: widgetId,
          statusCode: response.status,
          requestBody: {},
        })
      })
      .catch((error) => {
        toast.error(
          'Oops! Something went wrong. Please try again or contact Simplesat support for help.'
        )
        saveUserActivityLog({
          action: ACTION_NAME.delete_widget,
          target: widgetId,
          statusCode: error.response.status,
          requestBody: {},
        })
      })
  }

  return (
    <React.Fragment>
      <Switch>
        <Route path={match.path} exact>
          <TestimonialsPageV2
            widgets={R.prop('results', widgets) || []}
            createWidget={createWidget}
            deleteWidget={deleteWidget}
            createWidgetAPILoading={createWidgetAPILoading}
            deleteWidgetAPILoading={deleteWidgetAPILoading}
            widgetsLoading={widgetsLoading}
          />
        </Route>
        <Route path={`${match.path}:widgetId/`}>
          <PageHeaderContainer title="Feedback widgets" />
          <ContentContainer>
            <Link to={`/${match.params.workspaceToken}/settings/feedback-widgets/`}>
              <i className="fas fa-arrow-left icon" />
              Back to Feedback widgets
            </Link>

            <div className="ui segment !pl-10 !pr-10 !pb-10">
              <FeedbackWidgetSettingsContainer />
            </div>
          </ContentContainer>
        </Route>
      </Switch>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/TestimonialsV2/container.js